import './paggpixModal.scss';

import { Button, Container, Modal } from 'react-bootstrap';
import { FaCopy, FaKey } from 'react-icons/fa';
import { toast } from 'react-toastify';

import CustomModal from '@/resources/components/global/CustomModal';
import MoneyDisplay from '@/resources/components/global/MoneyDisplay/MoneyDisplay';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { IShipmentPayment } from '@/store/ducks/order/types';

interface PixPaymentProps {
  show: boolean | undefined;
  onHide: () => void;
}

export function PaggpixPayment({ show, onHide }: PixPaymentProps) {
  const { configs, order } = useWebContext();

  const companyImage = configs?.logo;

  const payment: IShipmentPayment | undefined = order?.payments?.find(
    (p) => p.type === 'paggpix' && p.status !== 'canceled',
  );

  const payment_qrcode = payment?.payment_qrcode || '';
  const total_paid = payment?.total_paid || 0;
  const pix_copy_code = payment?.pix_copy_code || '';

  const handleCopy = async () => {
    try {
      navigator.clipboard.writeText(pix_copy_code);
      toast.success('Código copiado com sucesso!');
    } catch (err) {
      toast.error(`Erro ao copiar o código. ${err}`);
    }
  };

  return (
    <CustomModal
      show={show ?? false}
      onHide={onHide}
      className="d-flex justify-content-center modal-rounded desktop-modal"
      centered
      size="md"
    >
      <Modal.Header className="d-flex justify-content-center align-items-center" closeButton>
        <img src={companyImage || ''} className="company-image" />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Container className="pix-container d-flex flex-column montserrat  align-items-center">
          <div className="d-flex flex-column align-items-center justify-content-center w-100 pt-2 pl-1">
            <span className="fs-bolder d-flex flex-row justify-content-start payment-title">
              Pagamento
            </span>
            <div className="info-container details">
              Escaneie o QR Code ou copie o código abaixo para realizar o pagamento.
            </div>
          </div>
          <div className="d-flex flex-column align-items-center justify-content-start w-100 pix-content-container">
            <div className="pix-key-container d-flex flex-row justify-content-start w-100 gap-3">
              <div className="qrcode-container justify-content-center text-center my-3">
                <img
                  className="img-fluid qrcode-image"
                  src={payment_qrcode}
                  title={pix_copy_code}
                  alt="payment_qrcode"
                />
              </div>
              <div className="copy-and-paste d-flex flex-column align-items-center gap-1">
                <div className="payment-price d-flex flex-column justify-content-start mt-4 pt-1 fs-bolder ml-0 pl-0">
                  <span className="price-label">Valor total: </span>
                  <span className="price-amount">
                    <MoneyDisplay value={total_paid} />
                  </span>
                </div>
                <div className="pix-key-label mb-1 mr-auto d-flex align-items-center mt-2">
                  <div className="key-icon">
                    <FaKey color="white" size={10} />
                  </div>
                  <label className="key-label mb-0 ml-1">Pix copia e cola: </label>
                </div>{' '}
                <textarea
                  value={pix_copy_code}
                  readOnly
                  title="Clique para copiar"
                  onClick={handleCopy}
                  className="
                    w-100 pix-textarea mb-1"
                />
                <div className="d-flex justify-content-center mb-3 w-100">
                  <Button
                    className="copy-and-paste-btn d-flex flex-row w-100 justify-content-center align-items-center"
                    onClick={handleCopy}
                  >
                    <FaCopy className="mr-2" />
                    Copiar código
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Modal.Body>
    </CustomModal>
  );
}
